import React from 'react'

import { getMqtt, GetMQTTResponse } from '@/api/mqtt.api'

const useDeviceMeasurementsHistory = (deviceId: string | undefined, selectedTemplateId: string, refreshKey: string) => {
  const [deviceMeasurementsHistory, setDeviceMeasurementsHistory] = React.useState<GetMQTTResponse[] | null>(null)
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const [error, setError] = React.useState<Error | null>(null)

  React.useEffect(() => {
    if (deviceId && selectedTemplateId) {
      const fetchMqttData = async () => {
        setIsLoading(true)
        setError(null)

        try {
          const mqttData = await getMqtt({ id: deviceId, selectedTemplateId })

          setDeviceMeasurementsHistory(mqttData)
        } catch (err) {
          setError(err instanceof Error ? err : new Error('Failed to fetch MQTT data'))
          setDeviceMeasurementsHistory(null)
        } finally {
          setIsLoading(false)
        }
      }

      fetchMqttData()
    }
  }, [deviceId, selectedTemplateId, refreshKey])

  return { deviceMeasurementsHistory, isLoading, error }
}

export default useDeviceMeasurementsHistory
